import { useMemo, useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import { Card, Col, Row, Button } from 'react-bootstrap';
import Alert from 'react-bootstrap/Alert';
import PageTitle from '../../../includes/PageTitle';
import Tables from '../../../components/Tables/Tables';
import Modals from '../../../components/Modals/Modals';
import Loader from '../../../components/Loader/Loader';
import SelectFild from '../../../components/SelectFild/SelectFild';
import { useFormik } from 'formik';
import { ToastContainer, toast } from 'react-toastify';
import { postCommonMaster, postSubCategory, postCategorySubAdd, getCategoryDetails, deleteCategory, patchCategoryUpdate } from '../../../apiservices/ApiServices';

const ProductSubCategory = () => {
    const [show, setShow] = useState(false);
    const [isLoading, setLoading] = useState(true);
    const [isLoadings, setLoadings] = useState(false);
    const [addModal, setAddModal] = useState(false);
    const [editModal, setEditModal] = useState(false);
    const [data, setData] = useState([]);
    const [commonMaster, setCommonMaster] = useState([]);
    const { id } = useParams();

    const [rowClientCentricSelections, setRowClientCentricSelections] = useState({});
    const [rowBillingCentricSelections, setRowBillingCentricSelections] = useState({});

    const [selectedClientCentricObjects, setSelectedClientCentricObjects] = useState([]);
    const [selectedBillingCentricObjects, setSelectedBillingCentricObjects] = useState([]);

    const postSubCategorys = async (id, postData) => {
        setLoading(true);
        try {
            const res = await postSubCategory(id, postData);
            setData(res.data.data);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    const postUpdateSubCategorys = async () => {
        let postData = {
            "search": "",
            "filters": { "category_name": "" },
            "page": 1,
            "length": 100
        };
        try {
            const res = await postSubCategory(id, postData);
            setData(res.data.data);
        } catch (error) {
            console.log(error.response?.data?.message || "Error submitting data");
        }
    };

    useEffect(() => {
        let postData = {
            "search": "",
            "filters": { "category_name": "" },
            "page": 1,
            "length": 100
        };
        postSubCategorys(id, postData);
    }, [id]);

    const columns = useMemo(
        () => [
            {
                Header: "Product Sub-Category Name",
                accessor: "category_name"
            },
            {
                Header: "Action",
                accessor: "action",
                disableSortBy: true
            },
        ],
        []
    );

    const actions = ['edit', 'delete'];
    const subActions = [];

    const emptyStatement = {
        eId: '',
        eName: '',
        eDescription: '',
        eActivityTemplate: [],
        eClientCentricIds: [],
        eBillingEntityCentricIds: [],
        subCategory: {
            name: '',
            description: '',
            activityTemplate: [],
            clientCentricIds: [],
            billingEntityCentricIds: [],
        }
    };

    const [initialFormikValues, setInitialFormikValues] = useState({
        subCategory: [emptyStatement]
    });

    const add = (index) => {
        const newIndex = values.subCategory.length;
        setFieldValue('subCategory', [...values.subCategory, { ...emptyStatement }]);


        if (data?.category?.client_centric.length > 0) {
            const selectedValues = data?.category?.client_centric.map(
                item => item.id
            );
            setFieldValue(`subCategory[${index}].clientCentricIds`, selectedValues);
        } else {
            setFieldValue(`subCategory[${index}].clientCentricIds`, []);
        }

        if (data?.category?.billing_entity_centric.length > 0) {
            const selectedValues = data?.category?.billing_entity_centric.map(
                item => item.id
            );
            setFieldValue(`subCategory[${index}].billingEntityCentricIds`, selectedValues);
        } else {
            setFieldValue(`subCategory[${index}].billingEntityCentricIds`, []);
        }

        setRowClientCentricSelections(prev => ({ ...prev, [newIndex]: [] }));
        setRowBillingCentricSelections(prev => ({ ...prev, [newIndex]: [] }));
    };

    const remove = (index) => {
        const updated = values.subCategory.filter((_, i) => i !== index);
        setFieldValue('subCategory', updated);
        setRowClientCentricSelections(prev => {
            const newState = { ...prev };
            delete newState[index];
            return newState;
        });
        setRowBillingCentricSelections(prev => {
            const newState = { ...prev };
            delete newState[index];
            return newState;
        });
    };

    const addnew = async () => {
        formik.resetForm();
        setLoadings(true);
        let postData = {
            type: [
                "client_centric",
                "billing_entity_centric",
                "activity_template"
            ],
            org_type_code: ''
        };
        try {
            const res = await postCommonMaster(postData);
            setCommonMaster(res.data.data);

            if (data?.category?.client_centric.length > 0) {
                const selectedValues = data?.category?.client_centric.map(
                    item => item.id
                );
                setFieldValue(`subCategory[0].clientCentricIds`, selectedValues);
            } else {
                setFieldValue(`subCategory[0].clientCentricIds`, []);
            }

            if (data?.category?.billing_entity_centric.length > 0) {
                const selectedValues = data?.category?.billing_entity_centric.map(
                    item => item.id
                );
                setFieldValue(`subCategory[0].billingEntityCentricIds`, selectedValues);
            } else {
                setFieldValue(`subCategory[0].billingEntityCentricIds`, []);
            }

            setLoadings(false);
            setAddModal(true);
        } catch (error) {
            setLoadings(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    const transformFormValuesToPostData = (values) => {
        return {
            category_id: id,
            sub_categories: values.subCategory.map((item, idx) => ({
                category_name: item?.name,
                category_description: item?.description,
                activity_template_ids: item?.activityTemplate,
                client_centric_ids: (rowClientCentricSelections[idx] || []).map(role => ({
                    id: role.id,
                    is_multiple: role.is_multiple ? 1 : 0
                })),
                billing_entity_centric_ids: (rowBillingCentricSelections[idx] || []).map(role => ({
                    id: role.id,
                    is_multiple: role.is_multiple ? 1 : 0
                })),
            })),
        };
    };

    const formik = useFormik({
        initialValues: initialFormikValues,
        validationSchema: '',
        onSubmit: async (values) => {
            setLoadings(true);
            if (addModal) {
                const postData = transformFormValuesToPostData(values);
                try {
                    const res = await postCategorySubAdd(postData);
                    toast.success(res.data.message);
                    postUpdateSubCategorys();
                    setLoadings(false);
                    setAddModal(false);
                    formik.resetForm();
                } catch (error) {
                    setLoadings(false);
                    toast.error(error.response?.data?.message || "Error submitting data");
                }
            }
            if (editModal) {
                const clientCentricIds = selectedClientCentricObjects.map(obj => ({
                    id: obj.id,
                    is_multiple: obj.is_multiple ? 1 : 0
                }));

                const billingEntityCentricIds = selectedBillingCentricObjects.map(obj => ({
                    id: obj.id,
                    is_multiple: obj.is_multiple ? 1 : 0
                }));


                let postData = {
                    parent_category_id: id,
                    category_name: values.eName,
                    category_description: values.eDescription,
                    activity_template_ids: values.eActivityTemplate,
                    client_centric_ids: clientCentricIds,
                    billing_entity_centric_ids: billingEntityCentricIds
                };
                try {
                    const res = await patchCategoryUpdate(values.eId, postData);
                    toast.success(res.data.message);
                    setLoadings(false);
                    postUpdateSubCategorys();
                    setEditModal(false);
                    formik.resetForm();
                } catch (error) {
                    setLoadings(false);
                    toast.error(error.response?.data?.message || "Error submitting data");
                }
            }
        },
    });

    const { values, handleChange, handleBlur, handleSubmit, setFieldValue, errors, touched } = formik;


    useEffect(() => {
        if (!commonMaster?.client_centric) return;

        const newRowClient = {};
        const newRowBilling = {};

        values.subCategory.forEach((cat, idx) => {
            const clientIds = cat.clientCentricIds || [];
            newRowClient[idx] = clientIds.map(id => {
                const item = commonMaster.client_centric.find(c => c.id === id);
                if (!item) return null;
                const existing = rowClientCentricSelections[idx]?.find(s => s.id === id);
                return {
                    ...item,
                    is_multiple: existing ? existing.is_multiple : false
                };
            }).filter(Boolean);

            const billingIds = cat.billingEntityCentricIds || [];
            newRowBilling[idx] = billingIds.map(id => {
                const item = commonMaster.billing_entity_centric.find(b => b.id === id);
                if (!item) return null;
                const existing = rowBillingCentricSelections[idx]?.find(s => s.id === id);
                return {
                    ...item,
                    is_multiple: existing ? existing.is_multiple : false
                };
            }).filter(Boolean);
        });

        setRowClientCentricSelections(prev => ({ ...prev, ...newRowClient }));
        setRowBillingCentricSelections(prev => ({ ...prev, ...newRowBilling }));
    }, [values.subCategory, commonMaster]);

    useEffect(() => {
        if (commonMaster?.client_centric) {
            setSelectedClientCentricObjects(prev => {
                const newIds = values.eClientCentricIds || [];
                const newObjects = newIds.map(id => {
                    const item = commonMaster.client_centric.find(c => c.id === id);
                    if (!item) return null;
                    const existing = prev.find(p => p.id === id);
                    return {
                        ...item,
                        is_multiple: existing ? existing.is_multiple : false
                    };
                }).filter(Boolean);
                return newObjects;
            });
        } else if (!values.eClientCentricIds?.length) {
            setSelectedClientCentricObjects([]);
        }
    }, [values.eClientCentricIds, commonMaster?.client_centric]);

    useEffect(() => {
        if (commonMaster?.billing_entity_centric) {
            setSelectedBillingCentricObjects(prev => {
                const newIds = values.eBillingEntityCentricIds || [];
                const newObjects = newIds.map(id => {
                    const item = commonMaster.billing_entity_centric.find(b => b.id === id);
                    if (!item) return null;
                    const existing = prev.find(p => p.id === id);
                    return {
                        ...item,
                        is_multiple: existing ? existing.is_multiple : false
                    };
                }).filter(Boolean);
                return newObjects;
            });
        } else if (!values.eBillingEntityCentricIds?.length) {
            setSelectedBillingCentricObjects([]);
        }
    }, [values.eBillingEntityCentricIds, commonMaster?.billing_entity_centric]);

    const handleConfirm = () => {
        setAddModal(false);
        setEditModal(false);
        formik.resetForm();
        setRowClientCentricSelections({});
        setRowBillingCentricSelections({});
    };

    const handleEdit = async (rowData) => {
        setLoadings(true);
        let postData = {
            type: [
                "client_centric",
                "billing_entity_centric",
                "activity_template"
            ],
            org_type_code: ''
        }
        try {
            const resp = await postCommonMaster(postData);
            setCommonMaster(resp.data.data);
            try {
                const res = await getCategoryDetails(rowData?.category_id);
                setFieldValue('eId', res.data?.data?.category_id);
                setFieldValue('eName', res.data?.data?.category_name);
                setFieldValue('eDescription', res.data?.data?.category_description);
                setFieldValue('eActivityTemplate', res.data?.data?.activity_template_ids);

                const clientCentricIds = res.data?.data?.client_centric?.map(item => item.id) || [];
                const billingEntityCentricIds = res.data?.data?.billing_entity_centric?.map(item => item.id) || [];

                setFieldValue('eClientCentricIds', clientCentricIds);
                setFieldValue('eBillingEntityCentricIds', billingEntityCentricIds);

                setSelectedClientCentricObjects([]);
                setSelectedBillingCentricObjects([]);
                setLoadings(false);
                setEditModal(true);

                setSelectedClientCentricObjects(res.data?.data?.client_centric);
                setSelectedBillingCentricObjects(res.data?.data?.billing_entity_centric);
            } catch (error) {
                setLoadings(false);
                setEditModal(false);
            }
        } catch (error) {
            setLoadings(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    const handleDelete = (rowData) => {
        setShow(true);
        setFieldValue('eId', rowData?.category_id);
        setFieldValue('eName', rowData?.category_name);
    };

    const handleDeleteCon = async () => {
        setLoadings(true);
        try {
            const res = await deleteCategory(values.eId);
            toast.success(res.data.message);
            setLoadings(false);
            setShow(false);
            postUpdateSubCategorys();
            formik.resetForm();
        } catch (error) {
            setLoadings(false);
            setShow(false);
        }
    };

    return (
        <>
            <ToastContainer
                position="top-right"
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                style={{ zIndex: 9999999999, position: 'fixed' }}
            />
            {isLoading ? <Loader /> :
                <>
                    <PageTitle titles={data?.category?.category_name + ' Product Sub-Category'} active={data?.category?.category_name + ' Product Sub-Category'} items={['Home']} />
                    <Row>
                        <Col sm={12} className="col-12">
                            <Card>
                                <Card.Body className="example1-table">
                                    <div className='custompageHed'>
                                        <Row>
                                            <Col md={6}>
                                                <div className='pagetitle_hed'>
                                                    <h1>{data?.category?.category_name} - Product Sub-Category</h1>
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className='w-100 d-flex justify-content-end'>
                                                    <button type='button' className='btn btn-primary' onClick={() => addnew()}>Add New</button>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                    <Tables
                                        columns={columns}
                                        data={data?.records}
                                        actions={actions}
                                        subActions={subActions}
                                        onEdit={handleEdit}
                                        onDelete={handleDelete}
                                    />
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </>
            }


            <Modals
                show={addModal}
                handleClose={() => setAddModal(false)}
                title="Add New"
                textColor='#000'
                size='xl'
                centered={true}
                backdrop={true}
                onConfirm={handleConfirm}
            >
                <form onSubmit={handleSubmit} autoComplete="off">
                    {values.subCategory.map((category, index) => (
                        <div key={index} className="fieldsets mainFS">
                            <div className='fieldsetsboxs'>
                                <h6>Product Sub-Category {index + 1}</h6>
                                <div className="addreovebtns">
                                    <button type="button" className="btn add-btn" onClick={() => add(index + 1)}>+</button>
                                    {values.subCategory.length > 1 && (
                                        <button type="button" className="btn remove-btn" onClick={() => remove(index)}>-</button>
                                    )}
                                </div>
                            </div>
                            <div className='formsBox'>
                                <Row>
                                    <Col md={4}>
                                        <div className="form-group">
                                            <label className="form-label">Product Sub-Category Name</label>
                                            <input type="text"
                                                name="name"
                                                className="form-control"
                                                autoComplete='off'
                                                value={category.name}
                                                onChange={(e) => setFieldValue(`subCategory[${index}].name`, e.target.value)}
                                            />
                                            {errors?.subCategory?.[index]?.name && touched?.subCategory?.[index]?.name && (
                                                <p className="errormsg">{errors.subCategory[index].name}</p>
                                            )}
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="form-group">
                                            <label className="form-label">Description</label>
                                            <input type="text"
                                                name="description"
                                                className="form-control"
                                                autoComplete='off'
                                                value={category.description}
                                                onChange={(e) => setFieldValue(`subCategory[${index}].description`, e.target.value)}
                                            />
                                            {errors?.subCategory?.[index]?.description && touched?.subCategory?.[index]?.description && (
                                                <p className="errormsg">{errors.subCategory[index].description}</p>
                                            )}
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="form-group">
                                            <label className="form-label">Select Applicable Activity Template</label>
                                            <SelectFild
                                                Firstop='Select Applicable Activity Template'
                                                selectName='activityTemplate'
                                                options={commonMaster?.activity_template}
                                                value={category.activityTemplate}
                                                onChange={(selectedOptions) => {
                                                    const selectedValues = selectedOptions ?
                                                        Array.isArray(selectedOptions) ?
                                                            selectedOptions.map(option => option.value) :
                                                            selectedOptions.value :
                                                        [];
                                                    setFieldValue(`subCategory[${index}].activityTemplate`, selectedValues);
                                                }}
                                                onBlur={() => handleBlur(`subCategory[${index}].activityTemplate`)}
                                                isMulti={true}
                                            />
                                            {errors.subCategory && errors.subCategory[index]?.activityTemplate && touched.subCategory?.[index]?.activityTemplate && (
                                                <p className="errormsg">{errors.subCategory[index].activityTemplate}</p>
                                            )}
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className="form-group">
                                            <label className="form-label">Select Client Centric Role</label>
                                            <SelectFild
                                                Firstop='Select Client Centric Role'
                                                selectName={`subCategory[${index}].clientCentricIds`}
                                                options={commonMaster?.client_centric}
                                                value={category.clientCentricIds}
                                                onChange={(selectedOptions) => {
                                                    const selectedValues = selectedOptions ?
                                                        Array.isArray(selectedOptions) ?
                                                            selectedOptions.map(option => option.value) :
                                                            selectedOptions.value :
                                                        [];
                                                    setFieldValue(`subCategory[${index}].clientCentricIds`, selectedValues);
                                                }}
                                                onBlur={() => handleBlur(`subCategory[${index}].clientCentricIds`)}
                                                isMulti={true}
                                            />
                                            {errors.subCategory && errors.subCategory[index]?.clientCentricIds && touched.subCategory?.[index]?.clientCentricIds && (
                                                <p className="errormsg">{errors.subCategory[index].clientCentricIds}</p>
                                            )}
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className="form-group">
                                            <label className="form-label">Select Billing Entity Centric Role</label>
                                            <SelectFild
                                                Firstop='Select Billing Entity Centric Role'
                                                selectName={`subCategory[${index}].billingEntityCentricIds`}
                                                options={commonMaster?.billing_entity_centric}
                                                value={category.billingEntityCentricIds}
                                                onChange={(selectedOptions) => {
                                                    const selectedValues = selectedOptions ?
                                                        Array.isArray(selectedOptions) ?
                                                            selectedOptions.map(option => option.value) :
                                                            selectedOptions.value :
                                                        [];
                                                    setFieldValue(`subCategory[${index}].billingEntityCentricIds`, selectedValues);
                                                }}
                                                onBlur={() => handleBlur(`subCategory[${index}].billingEntityCentricIds`)}
                                                isMulti={true}
                                            />
                                            {errors.subCategory && errors.subCategory[index]?.billingEntityCentricIds && touched.subCategory?.[index]?.billingEntityCentricIds && (
                                                <p className="errormsg">{errors.subCategory[index].billingEntityCentricIds}</p>
                                            )}
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        {rowClientCentricSelections[index]?.length > 0 && (
                                            <div className="fieldsets mainFS">
                                                <div className='fieldsetsboxs'>
                                                    <h6>Selected Client Centric Role</h6>
                                                </div>
                                                <div className='formsBox'>
                                                    <table className="table">
                                                        <thead>
                                                            <tr>
                                                                <th>Name</th>
                                                                <th style={{ width: 100 }}>Is Multiple</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {rowClientCentricSelections[index].map(obj => (
                                                                <tr key={obj.id}>
                                                                    <td>{obj.name}</td>
                                                                    <td>
                                                                        <div className="switchs" style={{ display: 'block', margin: '0 auto' }}>
                                                                            <input
                                                                                type="checkbox"
                                                                                id={`swi_client_${index}_${obj.id}`}
                                                                                className="form-control"
                                                                                autoComplete="off"
                                                                                checked={obj.is_multiple || false}
                                                                                onChange={(e) => {
                                                                                    setRowClientCentricSelections(prev => ({
                                                                                        ...prev,
                                                                                        [index]: prev[index].map(item =>
                                                                                            item.id === obj.id
                                                                                                ? { ...item, is_multiple: e.target.checked }
                                                                                                : item
                                                                                        )
                                                                                    }));
                                                                                }}
                                                                            />
                                                                            <span className="slider round"></span>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        )}
                                    </Col>
                                    <Col md={6}>
                                        {rowBillingCentricSelections[index]?.length > 0 && (
                                            <div className="fieldsets mainFS">
                                                <div className='fieldsetsboxs'>
                                                    <h6>Selected Billing Entity Centric Role</h6>
                                                </div>
                                                <div className='formsBox'>
                                                    <table className="table">
                                                        <thead>
                                                            <tr>
                                                                <th>Name</th>
                                                                <th style={{ width: 100 }}>Is Multiple</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {rowBillingCentricSelections[index].map(obj => (
                                                                <tr key={obj.id}>
                                                                    <td>{obj.name}</td>
                                                                    <td>
                                                                        <div className="switchs" style={{ display: 'block', margin: '0 auto' }}>
                                                                            <input
                                                                                type="checkbox"
                                                                                id={`swi_billing_${index}_${obj.id}`}
                                                                                className="form-control"
                                                                                autoComplete="off"
                                                                                checked={obj.is_multiple || false}
                                                                                onChange={(e) => {
                                                                                    setRowBillingCentricSelections(prev => ({
                                                                                        ...prev,
                                                                                        [index]: prev[index].map(item =>
                                                                                            item.id === obj.id
                                                                                                ? { ...item, is_multiple: e.target.checked }
                                                                                                : item
                                                                                        )
                                                                                    }));
                                                                                }}
                                                                            />
                                                                            <span className="slider round"></span>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        )}
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    ))}
                    <div className='modalfooters'>
                        <div className='button-boxs grid'>
                            <button type='submit' className='btn btn-primary'>Save</button>
                            <button type='button' onClick={handleConfirm} className='btn btn-default'>Cancel</button>
                        </div>
                    </div>
                </form>
            </Modals>

            <Modals
                show={editModal}
                handleClose={() => setEditModal(false)}
                title="Edit Sub Category"
                textColor='#000'
                size='xl'
                centered={true}
                backdrop={true}
                onConfirm={handleConfirm}
            >
                <form onSubmit={handleSubmit} autoComplete="off">
                    <Row>
                        <Col md={4}>
                            <div className="form-group">
                                <label className="form-label">Product Sub-Category Name</label>
                                <input
                                    type='text'
                                    id="eName"
                                    name="eName"
                                    className="form-control"
                                    autoComplete='off'
                                    value={values.eName}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.eName && touched.eName && <p className="errormsg">{errors.eName}</p>}
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="form-group">
                                <label className="form-label">Description</label>
                                <input
                                    type='text'
                                    id="eDescription"
                                    name="eDescription"
                                    className="form-control"
                                    autoComplete='off'
                                    value={values.eDescription}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.eDescription && touched.eDescription && <p className="errormsg">{errors.eDescription}</p>}
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="form-group">
                                <label className="form-label">Select Applicable Activity Template</label>
                                <SelectFild
                                    Firstop='Select Applicable Activity Template'
                                    selectName='eActivityTemplate'
                                    options={commonMaster?.activity_template}
                                    value={values.eActivityTemplate}
                                    onChange={(selectedOptions) => {
                                        const selectedValues = selectedOptions ?
                                            Array.isArray(selectedOptions) ?
                                                selectedOptions.map(option => option.value) :
                                                selectedOptions.value :
                                            [];
                                        setFieldValue('eActivityTemplate', selectedValues);
                                    }}
                                    onBlur={() => handleBlur('eActivityTemplate')}
                                    isMulti={true}
                                />
                                {errors.eActivityTemplate && touched.eActivityTemplate && <p className="errormsg">{errors.eActivityTemplate}</p>}
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="form-group">
                                <label className="form-label">Select Client Centric Role</label>
                                <SelectFild
                                    Firstop='Select Client Centric Role'
                                    selectName='eClientCentricIds'
                                    options={commonMaster?.client_centric}
                                    value={values.eClientCentricIds}
                                    onChange={(selectedOptions) => {
                                        const selectedValues = selectedOptions ?
                                            Array.isArray(selectedOptions) ?
                                                selectedOptions.map(option => option.value) :
                                                selectedOptions.value :
                                            [];
                                        setFieldValue('eClientCentricIds', selectedValues);
                                    }}
                                    onBlur={() => handleBlur('eClientCentricIds')}
                                    isMulti={true}
                                />
                                {errors.eClientCentricIds && touched.eClientCentricIds && <p className="errormsg">{errors.eClientCentricIds}</p>}
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="form-group">
                                <label className="form-label">Select Billing Entity Centric Role</label>
                                <SelectFild
                                    Firstop='Select Billing Entity Centric Role'
                                    selectName='eBillingEntityCentricIds'
                                    options={commonMaster?.billing_entity_centric}
                                    value={values.eBillingEntityCentricIds}
                                    onChange={(selectedOptions) => {
                                        const selectedValues = selectedOptions ?
                                            Array.isArray(selectedOptions) ?
                                                selectedOptions.map(option => option.value) :
                                                selectedOptions.value :
                                            [];
                                        setFieldValue('eBillingEntityCentricIds', selectedValues);
                                    }}
                                    onBlur={() => handleBlur('eBillingEntityCentricIds')}
                                    isMulti={true}
                                />
                                {errors.eBillingEntityCentricIds && touched.eBillingEntityCentricIds && <p className="errormsg">{errors.eBillingEntityCentricIds}</p>}
                            </div>
                        </Col>
                        <Col md={6}>
                            {selectedClientCentricObjects.length > 0 && (
                                <div className="fieldsets mainFS">
                                    <div className='fieldsetsboxs'>
                                        <h6>Selected Client Centric Role</h6>
                                    </div>
                                    <div className='formsBox'>
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th>Name</th>
                                                    <th style={{ width: 100 }}>Is Multiple</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {selectedClientCentricObjects.map(obj => (
                                                    <tr key={obj.id}>
                                                        <td>{obj.name}</td>
                                                        <td>
                                                            <div className="switchs" style={{ display: 'block', margin: '0 auto' }}>
                                                                <input
                                                                    type="checkbox"
                                                                    id={`swi_${obj.id}`}
                                                                    className="form-control"
                                                                    autoComplete="off"
                                                                    checked={obj.is_multiple || false}
                                                                    onChange={(e) => {
                                                                        setSelectedClientCentricObjects(prev =>
                                                                            prev.map(item =>
                                                                                item.id === obj.id
                                                                                    ? { ...item, is_multiple: e.target.checked }
                                                                                    : item
                                                                            )
                                                                        );
                                                                    }}
                                                                />
                                                                <span className="slider round"></span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            )}
                        </Col>
                        <Col md={6}>
                            {selectedBillingCentricObjects.length > 0 && (
                                <div className="fieldsets mainFS">
                                    <div className='fieldsetsboxs'>
                                        <h6>Selected Billing Entity Centric Role</h6>
                                    </div>
                                    <div className='formsBox'>
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th>Name</th>
                                                    <th style={{ width: 100 }}>Is Multiple</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {selectedBillingCentricObjects.map(obj => (
                                                    <tr key={obj.id}>
                                                        <td>{obj.name}</td>
                                                        <td>
                                                            <div className="switchs" style={{ display: 'block', margin: '0 auto' }}>
                                                                <input
                                                                    type="checkbox"
                                                                    id={`swi_${obj.id}`}
                                                                    className="form-control"
                                                                    autoComplete="off"
                                                                    checked={obj.is_multiple || false}
                                                                    onChange={(e) => {
                                                                        setSelectedBillingCentricObjects(prev =>
                                                                            prev.map(item =>
                                                                                item.id === obj.id
                                                                                    ? { ...item, is_multiple: e.target.checked }
                                                                                    : item
                                                                            )
                                                                        );
                                                                    }}
                                                                />
                                                                <span className="slider round"></span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            )}
                        </Col>
                    </Row>
                    <div className='modalfooters'>
                        <div className='button-boxs grid'>
                            <button type='submit' className='btn btn-primary'>Update</button>
                            <button type='button' onClick={handleConfirm} className='btn btn-default'>Cancel</button>
                        </div>
                    </div>
                </form>
            </Modals>

            {/* Delete Alert */}
            {show && (
                <>
                    <Alert variant="danger" onClose={() => setShow(false)} dismissible>
                        <Alert.Heading>Are you sure want to Delete <span>{values.eName}</span> Sub Category?</Alert.Heading>
                        <hr />
                        <div className='button-boxs grid'>
                            <div>
                                <button onClick={() => handleDeleteCon()} className='btn btn-primary'>OK</button>
                            </div>
                            <div>
                                <button onClick={() => setShow(false)} className='btn btn-default'>Cancel</button>
                            </div>
                        </div>
                    </Alert>
                    <div className='overly'></div>
                </>
            )}

            {isLoadings && <Loader />}
        </>
    );
};

export default ProductSubCategory;